import React, { useEffect, useState } from 'react';

const TC_THEME_KEY = 'tc-theme';

export function initTheme(): void {
  if (localStorage.getItem(TC_THEME_KEY) === 'light') {
    document.documentElement.setAttribute('data-theme', 'light');
  }
}

export function ThemeToggle() {
  const [isLight, setIsLight] = useState<boolean>(() => {
    return localStorage.getItem(TC_THEME_KEY) === 'light';
  });

  useEffect(() => {
    if (isLight) {
      document.documentElement.setAttribute('data-theme', 'light');
      localStorage.setItem(TC_THEME_KEY, 'light');
    } else {
      document.documentElement.removeAttribute('data-theme');
      localStorage.setItem(TC_THEME_KEY, 'dark');
    }
  }, [isLight]);

  return (
    <div className="tc-theme-toggle d-flex align-items-center gap-2 px-3">
      <i className="bi bi-moon-fill fs-6 tc-icon" title="Oscuro" />
      <div className="form-check form-switch mb-0">
        <input
          className="form-check-input"
          type="checkbox"
          id="tcThemeSwitch"
          checked={isLight}
          onChange={() => setIsLight((prev) => !prev)}
          title={isLight ? 'Cambiar a modo oscuro' : 'Cambiar a modo claro'}
        />
        <label className="visually-hidden" htmlFor="tcThemeSwitch">
          Tema
        </label>
      </div>
      <i className="bi bi-sun-fill fs-6 tc-icon" title="Claro" />
    </div>
  );
}
